import React, { useEffect, useState } from "react";
import {
  ChangeTitle,
  dateFormat,
  decrypt,
  selectFormStyle,
  toAbsoluteUrl,
  toasterrormsg,
  toastsuccessmsg,
} from "../../helpers/Reusable";
import Select from "react-select";
import { Link, useLocation } from "react-router-dom";
import { apiHeader, postData } from "../../helpers/ApiHelper";
import ArticleSkeleton from "../article/ArticleSkeleton";
import { IoClose } from "react-icons/io5";
import * as Yup from "yup";
import { useFormik } from "formik";
import { ToastContainer } from "react-toastify";
import ClipLoader from "react-spinners/ClipLoader";
import { getCookie } from "../../helpers/CookieComponent";

// Formik InitialValues
const initialValues = {
  articleCategoryId: "",
  question: "",
  description: "",
};

// Fromik Validation Schema
const schema = Yup.object().shape({
  articleCategoryId: Yup.string().trim().required("Please Select Category"),
  question: Yup.string().trim().required("Please Enter Question"),
  description: Yup.string().trim().required("Please Enter Description"),
});

const QueriesList = ({ id = "", type, date }) => {
  ChangeTitle("Queries");
  const [queriesList, setQueriesList] = useState([]);
  const [articleListEmptyMsg, setArticleListEmptyMsg] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const auth = decrypt(getCookie("token")) || "";


  console.log("categoryList", categoryList);

  const formik = useFormik({
    initialValues,
    validationSchema: schema,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);

      const param = {
        articleCategoryId: values.articleCategoryId,
        question: values.question,
        description: values.description,
      };

      const response = await postData(
        "private/queries/save",
        param,
        apiHeader(false)
      );

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        viewQueriesList(id);
        toastsuccessmsg(response.data.message);
        setTimeout(() => {
          setLoading(false);
          resetForm();
          closeModal();
        }, 1500);
      } else {
        console.log(response.data.message);
        toasterrormsg(response.data.message);
        setLoading(false);
      }
    },
  });

  // Article List API Call
  const viewQueriesList = async (id, date) => {
    const param = {
      articleCategoryId: id,
      date: date,
      limit: 0,
      offset: 0,
    };
    var response = await postData(
      "queries/user/question/list",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const categoryData = data.map((data) => {
        return {
          id: data._id,
          queriesImage: data.userDetail && data.userDetail.profile,
          fullName: data.userDetail.fullName && data.userDetail.fullName,
          profession: data.userDetail.profession && data.userDetail.profession,
          title:
            data.articleCategory.categoryName &&
            data.articleCategory.categoryName,
          tags: data.tags,
          question: data.question,
          publishDate: data.createdDate,
          description: data.description,
          answerCount: data.answerCount,
          viewCount: data.viewCount,
          postedOn: data.postedDate,
        };
      });
      if (data.length == 0) {
        setArticleListEmptyMsg("Queries Not Exist");
      } else {
        setArticleListEmptyMsg("");
      }
      setQueriesList(categoryData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Article Category List API Call
  const viewCatogoryList = async () => {
    var response = await postData(
      "article/category/list",
      {},
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const categoryData = data.map((data) => {
        return {
          value: data._id,
          label: data.categoryName,
        };
      });
      setCategoryList(categoryData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewCatogoryList();
  }, []);

  useEffect(() => {
    viewQueriesList(id, date);
  }, [id, date]);

  const openModal = () => {
    document.body.style.overflowY = "hidden";
    setIsModalOpen(true);
  };
  const closeModal = () => {
    document.body.style.overflowY = "";
    setIsModalOpen(false);
    formik.resetForm();
  };
  return (
    <>
      <ToastContainer />
      {isModalOpen === true && (
        <>
          <div
            onClick={closeModal}
            className={`w-full fixed top-0 left-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form getintouch`}
          >
            <div
              onClick={(e) => e.stopPropagation()} // Prevents click inside modal from closing it
              className="w-[90%] md:w-[80%] lg:w-[50%] xl:container p-[4%] lg:p-[2%] mx-auto my-[5%] lg:my-0 relative top-[25%] lg:top-1/2 transform lg:-translate-y-1/2 form-box"
            >
              <div className="flex items-center justify-between">
                <h1 className="mb-[3%] hanson">Ask question</h1>
                <IoClose
                  onClick={closeModal}
                  className="w-[3rem] h-[3rem] cursor-pointer"
                />
              </div>
              <div className="">
                <form onSubmit={formik.handleSubmit}>
                  <div className="w-full grid gap-[2rem] mb-[2rem]">
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Category
                      </label>
                      <Select
                        name="articleCategoryId"
                        id="articleCategoryId"
                        placeholder="Select Category"
                        className="w-full form-select form-input"
                        isSearchable={true}
                        options={categoryList}
                        value={categoryList.find(
                          (item) =>
                            item.value === formik.values.articleCategoryId
                        )}
                        onChange={(e) =>
                          formik.setFieldValue("articleCategoryId", e.value)
                        }
                        styles={selectFormStyle}
                      />
                      {formik.touched.articleCategoryId &&
                        formik.errors.articleCategoryId && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formik.errors.articleCategoryId}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Question
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter Question"
                        id="question"
                        value={formik.values.question}
                        onChange={formik.handleChange}
                      />
                      {formik.touched.question && formik.errors.question && (
                        <div className="mt-4 error-msg">
                          <div className="">{formik.errors.question}</div>
                        </div>
                      )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label mb-4 required"
                      >
                        Description
                      </label>
                      <textarea
                        placeholder="Enter Description"
                        type="text"
                        className="w-full form-input"
                        id="description"
                        value={formik.values.description}
                        onChange={formik.handleChange}
                      />
                      {formik.touched.description &&
                        formik.errors.description && (
                          <div className="mt-4 error-msg">
                            <div className="">{formik.errors.description}</div>
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="w-full justify-center gap-5 flex">
                    <button
                      type="submit"
                      className="btn-submit"
                      disabled={loading}
                    >
                      {!loading && <>Submit</>}
                      {loading && (
                        <div className="flex items-center gap-3">
                          <span className="" style={{ display: "block" }}>
                            Please wait...{" "}
                          </span>
                          <ClipLoader
                            color={"#ffffff"}
                            loading={loading}
                            size={20}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
      <div className="w-full lg:w-[90%] xl:w-[80%] p-[5%] sm:p-[2%] mx-auto flex flex-col gap-10 justify-center items-center sec-articles sec-queries-box">
        <div className="w-full text-end mx-auto">
          <button
            onClick={openModal}
            className="px-[4%] py-[1.5%] btn-add-question"
          >
            Ask question
          </button>
        </div>
        {queriesList.length == 0
          ? <h1 className="not-exist-msg">{articleListEmptyMsg}</h1> || (
              <ArticleSkeleton />
            )
          : queriesList.map((data) => (
              <Link
                // to="/queriesdetails"
                // state={{ aid: id, queriesId: data.id }}
                // className="w-full"
                to={auth ? "/queriesdetails" : "#"}
                state={auth ? { aid: id, queriesId: data.id } : {}}
                className="w-full"
                onClick={(e) => {
                  if (!auth) {
                    e.preventDefault(); // stop navigation
                    toasterrormsg("Please login first");
                  }
                }}
              >
                <div className="w-full p-[5%] sm:p-[2%] flex flex-col md:flex-row gap-10 md:gap-5 lg:gap-10 h-full cursor-pointer sqb-box">
                  <div className="w-full flex flex-col sm:flex-row gap-5 lg:gap-10">
                    <div className="w-[15%] xl:w-[10%]">
                      <img
                        className="w-full"
                        src={toAbsoluteUrl("media/img/tula/tula5.svg")}
                        // src={data.queriesImage}
                        alt="justice Image"
                      />
                    </div>
                    <div className="sm:w-[85%] xl:w-[90%]">
                      <div className="pb-[2%] mb-[2%] sqb-box-p1">
                        <h1 className="sqb-box-t1">{data.title}</h1>
                        <h2 className="mb-[1%] sqb-box-t2">{data.tags}</h2>
                        <h3 className="sqb-box-t3">{data.question}</h3>
                        <h4 className="mb-[2%] sqb-box-t4">
                          (Published date: {dateFormat(data.publishDate)})
                        </h4>
                        <p className="sqb-box-para">{data.description}</p>
                      </div>
                      <div className="w-full flex items-center sqb-box-p2">
                        {/* <div className="flex gap-3 items-center pr-[2%] sqbbp2-box">
                          <div>
                            <img
                              src={toAbsoluteUrl(
                                "media/img/icon/basic/arrow-left.svg"
                              )}
                              alt=""
                            />
                          </div>
                          <h1 className="sqb-box-p2-text">
                            Answer ({data.answerCount})
                          </h1>
                        </div> */}
                        <div className="flex gap-3 items-center px-[2%] sqbbp2-box">
                          <div>
                            <img
                              src={toAbsoluteUrl(
                                "media/img/icon/basic/eye-yellow.svg"
                              )}
                              alt=""
                            />
                          </div>
                          <h1 className="sqb-box-p2-text">
                            Views ({data.viewCount})
                          </h1>
                        </div>
                        <div className="flex gap-3 items-center px-[2%] sqbbp2-box">
                          <div>
                            <img
                              src={toAbsoluteUrl(
                                "media/img/icon/basic/clock.svg"
                              )}
                              alt=""
                            />
                          </div>
                          <h1 className="sqb-box-p2-text">
                            Posted {data.postedOn}
                          </h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
      </div>
    </>
  );
};

export default QueriesList;
